/* eslint-disable @typescript-eslint/naming-convention */
export const measuringPointOperatorsContent: string[] = [
    '__MOCK_FRONTEND',
    '1KOMMA5° GmbH',
    'acteno energy GmbH',
    'Activis Energy GmbH & Co. KG',
    'Aplus Energy GmbH',
    'badenova AG & Co. KG',
    'BlueMetering GmbH',
    'Braunschweiger Versorgungs-AG & Co. KG',
    'BUZZN GmbH',
    'co.met GmbH',
    'Comgy GmbH',
    'COUNT+CARE GmbH & Co. KG',
    'Countrol GmbH',
    'DB Kommunikationstechnik GmbH',
    'Deutsche Energieversorgung GmbH',
    'Dirk Rossmann GmbH',
    'Discovergy GmbH',
    'E.DIS Netz GmbH',
    'E.ON Energie Deutschland GmbH',
    'E.ON Metering GmbH',
    'e.optimum AG',
    'e.optimum home GmbH',
    'EE Infratec GmbH',
    'EGB Bauenergie GmbH',
    'EGT Energie GmbH',
    'EHA Energie-Handels-Gesells.mbH & Co. KG',
    'Elektrizitäts-Werk Ottersberg',
    'em.serv GmbH',
    'EnBW Energy Factory GmbH',
    'EnBW mobility+ AG & Co. KG',
    'enconsys GmbH',
    'Energiegenossenschaft für Wittmund eG',
    'ENOMETRIK',
    'Enpal GmbH',
    'envia Mitteldeutsche Energie AG',
    'EnviTec Energy GmbH & Co. KG',
    'EPR Metering GmbH',
    'EW Dienstleistung UG',
    'EWE NETZ GmbH',
    'EWE NETZ RVN GmbH',
    'EWE VERTRIEB GmbH',
    'ExtraEnergie GmbH',
    'GASAG Solution Plus GmbH',
    'GELSENWASSER AG',
    'GETEC metering GmbH',
    'Green Planet Solutions GmbH & Co. KG',
    'in.power metering GmbH',
    'INNAX Smart Metering GmbH',
    'innogy Metering GmbH',
    'inteligy GmbH',
    'ista SE',
    'KEHAG Messtechnik GmbH',
    'LCG Energy GmbH',
    'LichtBlick SE',
    'Management GmbH & Co. KG',
    'Maschinenringe Deutschland GmbH',
    'MER Solutions GmbH',
    'NaturStrom Energiedaten GmbH',
    'naturstrom vor Ort GmbH',
    'nvb smart GmbH',
    'opti.metering GmbH',
    'ovag Energie AG',
    'OVE GmbH & Co. KG',
    'PASM Power & Air Condition',
    'Qivalo GmbH',
    'QuaeroSys UG (haftungsbeschränkt)',
    'Reck Energietechnik AG',
    'Rhegio Dienstleistungen GmbH',
    'Rhegio Natur GmbH',
    'RhönEnergie Fulda GmbH',
    'Sagemcom IMD Center GmbH',
    'SENEC GmbH',
    'Solandeo GmbH',
    'Soluvia Energy Services GmbH',
    'SpotMyEnergy GmbH',
    'Stadtwerke Leipzig GmbH',
    'Stadtwerke Stade GmbH',
    'Stadtwerke Uelzen GmbH',
    'Stromkontor Netzgesellschaft mbH',
    'Sunvigo GmbH',
    'symbiotic services GmbH',
    'TEAG Thüringer Energie AG',
    'TEBO technisches Energiemanagement Bose GmbH',
    'Techem Energy Services',
    'Teleseo GmbH',
    'Tengelmann Energie GmbH',
    'Trianel GmbH',
    'Tribicon GmbH',
    'ubimeter GmbH',
    'URBANA Energiedienste GmbH',
    'VEA Beratungs-GmbH',
    'VOLTARIS GmbH',
    'Watt Synergia GmbH',
    'wattline GmbH',
    'Westenergie Metering GmbH',
    'White Grid GmbH',
    'Yello Strom GmbH',
    'Zählerhelden GmbH',
];
